<template>
  <v-card class="card-container">
    <v-dialog v-model="importDialog" max-width="400">
      <v-card flat class="pa-6 text-center">
        <div v-if="addResponse.notRegisteredDepartments">
          <strong>Alguns dos setores não foram importados</strong>
          <p class="mt-3">
            Parece que alguns dos setores adicionados já existem no sistema,
            estes não foram importados! O restante dos setores foi cadastrado
            com sucesso!
          </p>
        </div>

        <div v-else>
          <strong>Setores importados com sucesso!</strong>
          <p class="mt-3">
            Os setores foram importados e já estão disponiveis!
          </p>
        </div>

        <div class="d-flex justify-center align-center">
          <v-btn
            class="primary-button ma-0"
            depressed
            @click="
              ;(resendKey = !resendKey),
                (sectors = []),
                (importDialog = false),
                (file = null)
            "
          >
            Ok
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-file-input
      class="d-none"
      id="setorFile"
      accept=".xlsx"
      :key="resendKey"
      @change="readFile"
    ></v-file-input>

    <div class="back pt-3">
      <div class="main-toolbar mb-2">
        <div class="icon-back">
          <v-icon color="white" size="27">mdi-sticker-plus-outline</v-icon>
        </div>

        <span class="main-toolbar-title">Importar Setores</span>
      </div>

      <v-row class="ma-0" dense align="center">
        <v-col cols="12">
          <!-- <strong>Importação de Setores</strong> -->
          Aqui você pode importar uma planilha de setores para dentro do sistema
          com base na planilha modelo que fornecemos.
          <br />
          A cada importação, confirme se está com a planilha modelo atualizada
          para garantir o funcionamento correto.
        </v-col>
        <v-col v-if="sectors && sectors.length == 0">
          <label class="label">{{ $t('Arquivo') }}</label>
          <div class="d-flex justify-center">
            <v-file-input
              v-model="file"
              show-size
              accept=".xls, .xlsx"
              outlined
              dense
              prepend-icon=""
              prepend-inner-icon="mdi-paperclip"
              class="primary-input"
              hide-details="auto"
            >
            </v-file-input>
          </div>
        </v-col>
      </v-row>

      <v-row class="ma-0 my-4" v-if="sectors && sectors.length == 0">
        <v-col cols="12" sm="4" class="ma-0">
          <v-btn
            class="primary-button"
            depressed
            :disabled="loading"
            @click="downloadModel"
          >
            {{ $t('Baixar planilha modelo') }}
          </v-btn>
        </v-col>
        <v-col cols="12" sm="8" class="ma-0">
          <v-row style="justify-content: flex-end">
            <v-col cols="10" sm="4" class="ma-0">
              <v-btn
                class="secondary-button"
                @click="onFileChange"
                depressed
                :disabled="file == null"
                :loading="tableLoading"
              >
                {{ $t('Importar Arquivo') }}
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3" class="ma-0">
              <v-btn depressed @click="cancel" class="secondary-button mr-0">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div id="sectors">
          <v-form ref="form">
            <v-card
              class="ma-2 py-2"
              v-for="(sector, i) in sectors"
              :key="i"
              flat
              outlined
            >
              <v-row class="ma-0" dense>
                <v-col cols="1" class="d-flex justify-center align-center">
                  <strong>{{ i + 1 }}</strong>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="text ml-1">{{ $t('Nome') }}</span>
                  <v-text-field
                    v-model="sector.name"
                    hide-details="auto"
                    class="primary-input"
                    placeholder="0000"
                    outlined
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <span class="text ml-1">{{ $t('Sigla') }}</span>
                  <v-text-field
                    class="primary-input"
                    hide-details="auto"
                    v-model="sector.initials"
                    :maxlength="4"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    @keydown.enter="addDepartment()"
                    required
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="text ml-1">{{ $t('Unidade') }}</span>
                  <v-select
                    append-icon="mdi-chevron-down"
                    hide-details="auto"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :items="unidades"
                    v-model="sector.unidadeId"
                    clearable
                    item-value="id"
                    item-text="name"
                    class="primary-input"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    outlined
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </div>
      </v-expand-transition>

      <v-divider v-if="sectors.length > 0" class="my-4"></v-divider>

      <div class="d-flex" v-if="sectors.length > 0">
        <v-spacer></v-spacer>
        <v-btn
          class="primary-button ma-1"
          depressed
          @click="resend"
          :disabled="addLoading"
        >
          Refazer envio
        </v-btn>
        <v-btn
          class="secondary-button ma-1"
          depressed
          @click="addDepartments"
          :loading="addLoading"
        >
          Cadastrar setores
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'

export default {
  name: 'ImportDepartment',

  data() {
    return {
      loading: false,
      apiService: new ApiService(),
      sectors: [],
      unidades: [],
      importDialog: false,
      addResponse: {},
      resendKey: false,
      addLoading: false,
      file: null,
    }
  },

  created() {
    this.getUnidades()
  },

  methods: {
    resend() {
      this.resendKey = !this.resendKey
      this.sectors = []
    },

    readFile() {
      if (this.file) {
        const institutionId = JSON.parse(localStorage.getItem('institution')).id
        var reader = new FileReader()
        reader.readAsDataURL(this.file)
        reader.onload = () => {
          this.data = reader.result
          const fileModel = {
            File: this.data,
            InstitutionId: institutionId,
          }

          this.loading = true
          this.apiService
            .post('department/import', fileModel)
            .then((response) => {
              this.sectors = response.content
              this.loading = false
            })
            .catch(() => {
              this.loading = false
              this.resendKey = !this.resendKey
            })
        }
      }
    },

    downloadModel() {
      let link = document.createElement('a')
      link.setAttribute('type', 'hidden')
      link.href =
        'https://equipacarefix.blob.core.windows.net/public/modelo-setor.xlsx'
      link.download =
        'https://equipacarefix.blob.core.windows.net/public/modelo-setor.xlsx'
      document.body.appendChild(link)
      link.click()
      link.remove()
    },

    openPicker() {
      const input = document.getElementById('setorFile')
      if (input) input.click()
    },

    async getUnidades() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      let url = 'unidade/list'

      if (institutionId) {
        url = `unidade/list/${institutionId}`
      }

      await this.apiService.get(url).then((response) => {
        this.unidades = response.content
      })
    },

    async addDepartments() {
      if (this.$refs.form.validate()) {
        this.addLoading = true
        const model = {
          departments: this.sectors,
        }

        this.apiService
          .post('department/add-departments', model)
          .then((response) => {
            this.addResponse = response
            this.importDialog = true
            this.addLoading = false
          })
          .catch(() => {
            this.addLoading = false
          })
      } else {
        this.$toast.error('Verifique os campos dos setores e tente novamente')
        return
      }
    },

    onFileChange(file) {
      if (file) {
        this.readFile(file)
      }
    },

    cancel() {
      this.file = null
    },
  },
}
</script>

<style scoped>
#sectors {
  margin-top: 15px;
  max-height: 450px;
  overflow-y: auto;
}

#sectors::-webkit-scrollbar {
  background-color: #f9f9f9;
  width: 8px;
  border-radius: 6px;
}

#sectors::-webkit-scrollbar-thumb {
  background-color: #e9e9e9;
  width: 8px;
  border-radius: 6px;
}
</style>
